'use strict';

const gridBaseURL = 'components/translate.cfc?method=getTranslationForLanguageWeb',
    gridEditURL = 'components/translate.cfc?method=updateTranslation';

let lastSelection,
    jqTrainingGridObj,
    currentRow = 0,
    confirmationContainerSelector,
    selectedLanguage;

export function init(options) {

    if (!options) { options = {}; }
    if (!options.selector) { options.selector = {}; }
    if (!options.selector) { options.selector = '#jqGridTranslation'; }
    if (!options.formSelector) { options.formSelector = '#frmSearchTranslations'; }
    if (!options.selectedLanguage) { options.selectedLanguage = 'French'; }
    if (!options.confirmationSettings) { options.confirmationSettings = {}; }

    // Set Selected language instance variable
    selectedLanguage = options.selectedLanguage;

    // Setup Binding
    bindConfirmationPopup(options.confirmationSettings);
    bindLanguageSelect(options.languageSwitchSelector);

    $(options.formSelector).bind('submit', (e) => {
        e.preventDefault();
        searchTranslations();
    });

    jqTrainingGridObj = $(options.selector); // main grid jQuery object

    $('.jqButton').button(); // style buttons

    var gridURL = jQuery.param.querystring(gridBaseURL, {
        language: selectedLanguage,
    });

    // Init JQGrid
    jqTrainingGridObj.jqGrid({
        url: gridURL,
        editurl: gridEditURL,
        editData: {
            SelectedLanguage: selectedLanguage,
        },
        datatype: 'json',
        colNames: [
            'ID', 'English', selectedLanguage,
        ],
        colModel: [{
            name: 'ID',
            index: 'ID',
            width: 0,
            sorttype: 'int',
            editable: false,
            hidden: true,
        }, {
            name: 't_en',
            index: 't_en',
            width: 50,
            sorttype: 'text',
        }, {
            name: 't_selectedlanguage',
            index: 't_selectedlanguage',
            width: 50,
            sorttype: 'text',
            editable: true,
        }],
        rowNum: 20,
        rowList: [20, 40, 80, 100],
        autowidth: true,
        height: '100%',
        pager: '#jqGridTranslationPager',
        sortname: 't_en',
        viewrecords: true,
        sortorder: 'asc',
        onCellSelect: function (rowid, iCol, cellcontent, e) {
            switch (iCol) {
                case 2:
                    editTranslationLine(rowid, iCol, cellcontent, e);
                    jqGridShowConfirmation({
                        rowID: rowid,
                    });
                    break;
                case 3:
                    // save row button. Not currently available
                    confirmSave({ rowID: rowid });
                    break;
            }
        },
        onPaging: function () {
            confirmSave(); // save changes when switching pages
        },
    });
}

export function confirmSave(options) {
    if (!options) { options = {}; }
    if (!options.rowID) { options.rowID = currentRow; }

    var saveParams = {
        'restoreAfterError': false,
        'extraparam': {
            SelectedLanguage: selectedLanguage,
        },
        'successfunc': function (responce) {
            var result = jQuery.parseJSON(responce.responseText);

            if (result.SUCCESS) {
                jqGridEndEdit();
                return true;
            }

            // Display alert if something went wrong
            alert(result.MESSAGE);
            jqGridEndEdit();
            return false;
        },
    };

    jqTrainingGridObj.jqGrid(
        'saveRow',
        options.rowID,
        saveParams,
    );
}

export function cancelEdit() {
    jqTrainingGridObj.jqGrid('restoreRow', currentRow);
    $('.jqGridSearchStatusContainer').customHide();
    jqGridEndEdit();
    return false;
}

export function searchTranslations() {

    if (gridIsDirty()) {
        confirmSave({rowID: currentRow});
    }


    var searchURL = jQuery.param.querystring(gridBaseURL, {
        searchterm: $('#frmSearchTranslations').find('.js-search-term').val(),
        language: selectedLanguage,
        missingTranslation: $('#missingTranslation:checked').length,
    });

    jqTrainingGridObj.jqGrid('setGridParam', {
        url: searchURL,
        page: 1,
    }).trigger('reloadGrid');
}

function jqGridEndEdit() {
    $(confirmationContainerSelector).customHide();
}
function editTranslationLine(rowid) {

    var id = rowid;

    jqTrainingGridObj.setSelection(rowid, false);

    if (id) {
        // Save Previous Row
        confirmSave({ rowID: lastSelection });

        //Edit Current Row
        jqTrainingGridObj.jqGrid('editRow', id, {
            keys: true,
            url: gridEditURL,
            successfunc: function () {
                confirmSave({ rowID: id });
            },
        });
        lastSelection = id;
    }
}

function gridIsDirty() {

    if ($('tr#' + currentRow).attr('editable') === '1') {
        return true;
    }

    var dirtyRows = jqTrainingGridObj.jqGrid('getChangedCells', 'dirty');
    if (dirtyRows.length > 0) {
        return true;
    }

    return false;
}

function jqGridShowConfirmation(options) {
    var offset = $('#' + options.rowID).offset();
    $(confirmationContainerSelector).css('top', (offset.top - 99) + 'px').customShow();
    currentRow = options.rowID;
}

function bindConfirmationPopup(options) {
    if (!options) { options = {}; }
    if (!options.containerSelector) {
        options.containerSelector = '#js-translate-confirmation-container';
    }
    if (!options.confirmSelector) { options.confirmSelector = '.js-translate-confirm'; }
    if (!options.cancelSelector) { options.cancelSelector = '.js-translate-cancel'; }

    confirmationContainerSelector = options.containerSelector;

    $(options.confirmSelector).bind('click', (event) => {
        event.preventDefault();
        confirmSave();
    });

    $(options.cancelSelector).bind('click', (event) => {
        event.preventDefault();
        cancelEdit();
    });

}

function bindLanguageSelect(languageSwitchSelector) {
    $(languageSwitchSelector).bind('change', () => {
        var pageURL = jQuery.param.querystring('?page=settings_translation_admin', {
            selectedLanguage: $(languageSwitchSelector).val(),
        });
        window.location.replace(pageURL);
    });
}
